import React, { useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import { getStaffDateWise } from "../../api/attendanceReportApi";
import "./Attendance.css";

const today = () => new Date().toISOString().slice(0, 10);

/**
 * Direct port of digicampusbd's `staff-attendance-report-date-wise` ("Date
 * Wise Report") — every active staff's real attendance for one date, plus
 * arrival/departure lateness computed against their configured schedule
 * (`StaffAttendanceTimeConfiguration`). Confirmed via `StaffAttendanceReportService
 * .getDateWiseStaffAttendance` this is in-Java time-delta arithmetic (no
 * aggregation) — new `GET /api/attendance/reports/staff/date-wise` mirrors
 * the "Late by Xh Ym" / "Early Leave by Xh Ym" / "Just Time" / "Config Not
 * Found" phrasing.
 */
export default function StaffDateWiseReportPage() {
  const [date, setDate] = useState(today());
  const [rows, setRows] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSearch = async () => {
    setError("");
    setLoading(true);
    try {
      setRows(await getStaffDateWise(date));
    } catch (err) {
      setError("Failed to load staff attendance report.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>Staff Attendance — Date Wise Report</h1>
      </div>
      {error && <p style={{ color: "var(--color-danger)" }}>{error}</p>}
      <div className="attendance-filters">
        <label>
          Date
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} />
        </label>
        <button type="button" className="btn-primary" onClick={handleSearch}>
          Search
        </button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        rows && (
          <div className="table-scroll">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th>SL</th>
                  <th>Staff Name</th>
                  <th>Designation</th>
                  <th>Mobile</th>
                  <th>Status</th>
                  <th>In Time</th>
                  <th>Arrival</th>
                  <th>Out Time</th>
                  <th>Departure</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.staffId}>
                    <td>{r.serial}</td>
                    <td>{r.staffName}</td>
                    <td>{r.designation}</td>
                    <td>{r.mobileNo}</td>
                    <td>{r.attendanceStatus}</td>
                    <td>{r.inTime}</td>
                    <td>{r.arrivalStatus}</td>
                    <td>{r.outTime}</td>
                    <td>{r.departureStatus}</td>
                  </tr>
                ))}
                {rows.length === 0 && (
                  <tr>
                    <td colSpan={9}>No staff attendance recorded for this date.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        )
      )}
    </MainLayout>
  );
}
